import {l} from "types/typescriptdefinisjoner_lederplan";
import {regNavn} from "../../../felles/tjenester/tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {MøtedeltakerSkjemaModell, VelgMøtedeltakereSkjemaModell} from "../møte/komponenter/nyttMøteSkjema/nyttMøteVelgDeltakereSkjema";
import {BeregnetMøtevarighet, MøteRessurs} from "../../../felles/tjenester/ressurser/MøteRessurs";
import {VarighetMedLabel} from "../../../felles/tjenester/ressurser/SakRessurs";
import {RedigerEksternMøtedeltakerModell} from "../møte/komponenter/møteskjema/redigerEksternDeltakerSkjemalinje";
import moment from "moment";
import {GruppeRessurs} from "../../../felles/tjenester/ressurser/GruppeRessurs";
import {MalmøteRessurs} from "../../../felles/tjenester/ressurser/MalmøteRessurs";
import {IPromise, IQService} from "angular";
import {UuidGenerator} from "../../../felles/tjenester/UuidGenerator";
import {PubliseringSpesifikasjon} from "../møte/komponenter/nyttMøteSkjema/nyttMøtePubliseringSkjema";
import {klokkeslett5MinIntervaller, varigheter5MinIntervaller, VarigheterInnslag} from "felles/stoettefunk/datoer";


export class MalmøteTjeneste {

    static regNavn = "wm.gruppe.MalmøteTjeneste";

    static forInjisering() {
        return [
            regNavn.ng.$q,
            GruppeRessurs.regNavn,
            MalmøteRessurs.regNavn,
            regNavn.gettext.gettextCatalog,
            MalmøteTjeneste
        ]
    }

    constructor(private $q: IQService,
                private gruppeRes: GruppeRessurs,
                private malmøteRes: MalmøteRessurs,
                private gettextCatalog: gettextCatalog) {
    }

    møtemalSkjemaModell(gruppeId: string): IPromise<MøtemalSkjemaModell> {
        return this.$q.all([
            this.gruppeRes.hent(gruppeId).$promise,
            this.malmøteRes.hent(gruppeId).$promise])
            .then(respons => {
                const gruppe = respons[0];
                const møtemal = respons[1];
                return MøtemalSkjemaModell.nyMøtemalSkjemaModell(møtemal, gruppe, this.gettextCatalog);
            });
    }

}

export class MøtemalSkjemaModell implements VelgMøtedeltakereSkjemaModell {

    static nyMøtemalSkjemaModell(møtemal: l.MalmøteModell, gruppe: l.GruppeModell, gettextCatalog: gettextCatalog): MøtemalSkjemaModell {
        const modell = new MøtemalSkjemaModell();
        modell.spesifikasjon = {
            id: møtemal.id,
            tittel: møtemal.tittel, //todo kai aug 18 eksponer felt
            starttidspunkt: møtemal.starttidspunkt,
            behandlingsSted: møtemal.behandlingsSted,
            behandlingsMaate: møtemal.behandlingsMaate,
            erMoetePublisert: møtemal.erMoetePublisert,
            erProtokollPublisert: møtemal.erProtokollPublisert,
            //følgende blir populert ved lagring
            deltakere: [],
            varighet: null, //settes ved lagring
            saker: []
        };

        modell.gruppe = gruppe;
        modell.starttidspunkter = klokkeslett5MinIntervaller();
        modell.varigheter = varigheter5MinIntervaller(gettextCatalog);
        modell.varighet = _(modell.varigheter).find(varighet => varighet.verdi == møtemal.varighet);
        const saksvarigheter = varigheter5MinIntervaller(gettextCatalog);
        modell.saker = _(møtemal.saker).map(saksmal => SaksmalSkjemamodell.nySaksmalSkjemamodell(saksmal, saksvarigheter)).value();
        modell.beregnSluttdato();

        modell.deltakere = gruppe.medlemmer.map(medlem => ({medlem: medlem, skalDelta: false, skalSignereProtokoll: false}));
        modell.deltakere.forEach(deltaker => {
            const deltakerFraMal = _.find(møtemal.deltakere, d => d.medlem.id == deltaker.medlem.id);
            if (_.isNil(deltakerFraMal)) return;
            deltaker.skalDelta = true;
            deltaker.skalSignereProtokoll = deltakerFraMal.skalSignere;
        });

        return modell;
    }

    spesifikasjon: l.OppdaterMalmøteSpesifikasjon & PubliseringSpesifikasjon;
    gruppe: l.GruppeModell;
    starttidspunkter: string[];
    varigheter: VarigheterInnslag[];
    varighet: VarigheterInnslag;
    beregnetSluttDato: BeregnetMøtevarighet;
    saker: SaksmalSkjemamodell[];

    //VelgMøtedeltakereSkjemaModell impl
    deltakere: MøtedeltakerSkjemaModell[];
    eksterneDeltakere: RedigerEksternMøtedeltakerModell[]; //denne er ikke relevant for malmøte - men kreves av VelgMøtedeltakereSkjemaModell/wm-nytt-moete-velg-deltakere-skjema-komponenten

    somSpesifikasjon(): l.OppdaterMalmøteSpesifikasjon {
        this.spesifikasjon.varighet = this.varighet ? this.varighet.verdi : null;
        this.spesifikasjon.saker = this.saker.filter(sak => sak.erTittelAngitt()).map(sak => sak.somSpesifikasjon());
        this.spesifikasjon.deltakere = this.deltakere.filter(deltaker => deltaker.skalDelta).map(deltaker => ({medlemId: deltaker.medlem.id, skalSignere: deltaker.skalSignereProtokoll}));
        return this.spesifikasjon;
    }

    beregnSluttdato() {
        if (!this.spesifikasjon.starttidspunkt || !this.varighet) return;
        const startdato = moment(this.spesifikasjon.starttidspunkt, 'hh:mm');
        const møte = {
            dato: {start: startdato.toDate(), slutt: startdato.clone().add(this.varighet.verdi, 'minute').toDate()},
            saker: _(this.saker).map(sak => sak.somSpesifikasjon()).value()
        };
        this.beregnetSluttDato = MøteRessurs.beregnetMøtevarighet(møte)
    }
}

export class SaksmalSkjemamodell {

    static nySaksmalSkjemamodell(mal: l.MalsakModell, saksvarigheter: VarighetMedLabel[]) {
        const modell = new SaksmalSkjemamodell();
        modell.sakstype = mal.erPause ? SaksmalSkjemamodell.pauseSakstype() : mal.sakstype;
        modell.tema = mal.tema;
        modell.ansvarlig = mal.ansvarlig;
        modell.varighetMedLabel = mal.varighet ? _.find(saksvarigheter, {verdi: mal.varighet}) : null;
        modell.spesifikasjon = {
            id: mal.id,
            tittel: mal.tittel,
            beskrivelse: mal.beskrivelse,
            varighet: mal.varighet,
            temaId: modell.tema ? modell.tema.id : null,
            sakstypeId: modell.sakstype ? modell.sakstype.id : null,
            ansvarligId: modell.ansvarlig ? modell.ansvarlig.id : null,
            inkludertGenerertDokument: mal.inkludertGenerertDokument,
            erPause: mal.erPause,
            beslutningsforslagtittel: mal.beslutningsforslagtittel,
            beslutningsforslagbeskrivelse: mal.beslutningsforslagbeskrivelse,
            standardIMoete: mal.standardIMoete
        };

        return modell;
    }

    static nyTomSaksmalSkjemamodell(saksvarigheter: VarighetMedLabel[], uuidGenerator: UuidGenerator) {
        const modell = new SaksmalSkjemamodell();
        modell.spesifikasjon = {
            id: uuidGenerator.generer(),
            tittel: '',
            beskrivelse: '',
            temaId: null,
            sakstypeId: null,
            varighet: null,
            ansvarligId: null,
            inkludertGenerertDokument: l.InkludertGenerertDokument.ingen,
            erPause: false,
            beslutningsforslagtittel: '',
            beslutningsforslagbeskrivelse: '',
            standardIMoete: true
        };

        return modell;
    }

    static pauseSakstype(): l.SakstypeModell {
        return {navn: 'pause', id: 'pause', indeks: 0, kanIkkeSlettes: true};
    }

    sakstype: l.SakstypeModell;
    tema: l.TemaModell;
    ansvarlig: l.GruppeMedlemListeModell;
    varighetMedLabel: VarighetMedLabel;
    spesifikasjon: l.OppdaterMalsakSpesifikasjon;

    erTittelAngitt() {
        return !_.isEmpty(this.spesifikasjon.tittel);
    }

    erPauselement(): boolean {
        return _.isObject(this.sakstype) && this.sakstype.id === SaksmalSkjemamodell.pauseSakstype().id;
    }

    somSpesifikasjon(): l.OppdaterMalsakSpesifikasjon {
        this.spesifikasjon.varighet = _.isObject(this.varighetMedLabel) ? this.varighetMedLabel.verdi : null;
        this.spesifikasjon.erPause = this.erPauselement();

        if (this.erPauselement()) {
            this.spesifikasjon.temaId = null;
            this.spesifikasjon.sakstypeId = null;
            this.spesifikasjon.ansvarligId = null;
            this.spesifikasjon.inkludertGenerertDokument = l.InkludertGenerertDokument.ingen;
            this.spesifikasjon.beslutningsforslagtittel = null;
            this.spesifikasjon.beslutningsforslagbeskrivelse = null;
        } else {
            this.spesifikasjon.temaId = _.isObject(this.tema) ? this.tema.id : null;
            this.spesifikasjon.sakstypeId = _.isObject(this.sakstype) ? this.sakstype.id : null;
            this.spesifikasjon.ansvarligId = _.isObject(this.ansvarlig) ? this.ansvarlig.id : null;
            if (_.isEmpty(this.spesifikasjon.beslutningsforslagtittel)) this.spesifikasjon.beslutningsforslagtittel = null;
        }

        return this.spesifikasjon;
    }
}
